import React from "react";

/**
 * HK Tuning brand logo.
 * size: "sm" (h-8), "md" (h-10), "lg" (h-14), "xl" (h-20)
 */
export default function Logo({ size = "md", className = "" }) {
  const sizes = {
    sm: "h-8",
    md: "h-10",
    lg: "h-14",
    xl: "h-20",
  };
  return (
    <img
      src="/hk-logo.png"
      alt="HK Tuning"
      className={`${sizes[size] || sizes.md} w-auto object-contain ${className}`}
      draggable={false}
    />
  );
}
